/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { PlatformFrameworkOverviewPaginated } from '../model';
// @ts-ignore
import type { PlatformFrameworkSorting } from '../model';
// @ts-ignore
import type { ProjectType } from '../model';
/**
 * PlatformFrameworksApi - axios parameter creator
 */
export const PlatformFrameworksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Query the platform frameworks enabled for an organization
         * @param {string} organizationId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PlatformFrameworkSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {ProjectType} [projectType] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryOrganizationPlatformFrameworks: async (organizationId: string, page?: number, size?: number, sortBy?: PlatformFrameworkSorting | null, descending?: boolean | null, projectType?: ProjectType, name?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('queryOrganizationPlatformFrameworks', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}/platform-frameworks`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (projectType !== undefined) {
                localVarQueryParameter['project_type'] = projectType;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the platform framework catalog
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PlatformFrameworkSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationId] 
         * @param {ProjectType | null} [projectType] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPlatformFrameworks: async (page?: number, size?: number, sortBy?: PlatformFrameworkSorting | null, descending?: boolean | null, organizationId?: string | null, projectType?: ProjectType | null, name?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/platform-frameworks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (projectType !== undefined) {
                localVarQueryParameter['project_type'] = projectType;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlatformFrameworksApi - functional programming interface
 */
export const PlatformFrameworksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlatformFrameworksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Query the platform frameworks enabled for an organization
         * @param {string} organizationId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PlatformFrameworkSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {ProjectType} [projectType] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryOrganizationPlatformFrameworks(organizationId: string, page?: number, size?: number, sortBy?: PlatformFrameworkSorting | null, descending?: boolean | null, projectType?: ProjectType, name?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkOverviewPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryOrganizationPlatformFrameworks(organizationId, page, size, sortBy, descending, projectType, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.queryOrganizationPlatformFrameworks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query the platform framework catalog
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PlatformFrameworkSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationId] 
         * @param {ProjectType | null} [projectType] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryPlatformFrameworks(page?: number, size?: number, sortBy?: PlatformFrameworkSorting | null, descending?: boolean | null, organizationId?: string | null, projectType?: ProjectType | null, name?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkOverviewPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryPlatformFrameworks(page, size, sortBy, descending, organizationId, projectType, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformFrameworksApi.queryPlatformFrameworks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlatformFrameworksApi - factory interface
 */
export const PlatformFrameworksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlatformFrameworksApiFp(configuration)
    return {
        /**
         * 
         * @summary Query the platform frameworks enabled for an organization
         * @param {PlatformFrameworksApiQueryOrganizationPlatformFrameworksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryOrganizationPlatformFrameworks(requestParameters: PlatformFrameworksApiQueryOrganizationPlatformFrameworksRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkOverviewPaginated> {
            return localVarFp.queryOrganizationPlatformFrameworks(requestParameters.organizationId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.projectType, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the platform framework catalog
         * @param {PlatformFrameworksApiQueryPlatformFrameworksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPlatformFrameworks(requestParameters: PlatformFrameworksApiQueryPlatformFrameworksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkOverviewPaginated> {
            return localVarFp.queryPlatformFrameworks(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationId, requestParameters.projectType, requestParameters.name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for queryOrganizationPlatformFrameworks operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiQueryOrganizationPlatformFrameworksRequest {
    readonly organizationId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: PlatformFrameworkSorting | null

    readonly descending?: boolean | null

    readonly projectType?: ProjectType

    readonly name?: string | null
}

/**
 * Request parameters for queryPlatformFrameworks operation in PlatformFrameworksApi.
 */
export interface PlatformFrameworksApiQueryPlatformFrameworksRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: PlatformFrameworkSorting | null

    readonly descending?: boolean | null

    readonly organizationId?: string | null

    readonly projectType?: ProjectType | null

    readonly name?: string | null
}

/**
 * PlatformFrameworksApi - object-oriented interface
 */
export class PlatformFrameworksApi extends BaseAPI {
    /**
     * 
     * @summary Query the platform frameworks enabled for an organization
     * @param {PlatformFrameworksApiQueryOrganizationPlatformFrameworksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryOrganizationPlatformFrameworks(requestParameters: PlatformFrameworksApiQueryOrganizationPlatformFrameworksRequest, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).queryOrganizationPlatformFrameworks(requestParameters.organizationId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.projectType, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the platform framework catalog
     * @param {PlatformFrameworksApiQueryPlatformFrameworksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryPlatformFrameworks(requestParameters: PlatformFrameworksApiQueryPlatformFrameworksRequest = {}, options?: RawAxiosRequestConfig) {
        return PlatformFrameworksApiFp(this.configuration).queryPlatformFrameworks(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationId, requestParameters.projectType, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}

